import * as React from 'react';
import { TextReviewsNew } from "../../../../TextReviewsNew";

import textReviewsData from "./textReviews.json"

import * as main from '../../styles/main.module.scss';
import * as textReviews from './textReviews.module.scss'

export const TextReviews = ({ titleHide=false, btnText }) => {
  return (
    <section className={textReviews.textReviews}>
      <div className="container">
        <h2 className={main.mainTitle} style={{ display: titleHide ? "none" : "block" }}>
          Отзывы участников
        </h2>
        <TextReviewsNew data={textReviewsData} />
        <a href={"#widget"} data-target={"#widget"} className={`${main.mainBtn} ${textReviews.textReviews__btn}`}>
          {btnText || "Присоединиться"}
        </a>
      </div>
    </section>
  );
};

